import { useQuery } from '@tanstack/react-query';

import {
  getInvoicesAsParty,
  type GetInvoicesAsPartyResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import type { Invoice, InvoiceStatus } from '../../types';

import queryKeys from './../queryKeys';

export default function useInvoices(
  partyId: string,
  filter?: {
    status?: InvoiceStatus[];
    orderBy?: keyof Invoice;
    sort?: 'asc' | 'desc';
    from?: string;
  },
  options?: QueryOptions<GetInvoicesAsPartyResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.list(partyId, filter),
    queryFn: async () => {
      const result = await getInvoicesAsParty(
        {
          path: { party_id: partyId },
          query: {
            status: filter?.status,
            order_by: filter?.orderBy,
            sort: filter?.sort,
            invoice_date_le: filter?.from,
          },
        },
        wgApi,
      );

      return result.items;
    },
    ...options,
  });
}
